import { deploymentMetadataSchema } from './issue-report-contracts'

export async function loadDeploymentSha(
  fetchImplementation: typeof fetch = fetch
): Promise<string | null> {
  try {
    const response = await fetchImplementation('/flio-deployment.json', {
      headers: { Accept: 'application/json' },
    })
    if (!response.ok) return null
    const parsed = deploymentMetadataSchema.safeParse(await response.json())
    return parsed.success ? parsed.data.sourceSha : null
  } catch {
    return null
  }
}
